<template>
	<c-dialog ref="dialog" mode="slide" width="80vw" enable-flex mask-close :button="false">
		<template #head>
			<div v-if="order.order_no" class="m-detail-tag flex-center-cross">
				<label>{{order.order_no}}</label>
				<!--详情接口不下发 display_state，状态标签由端内自己算，和列表同一套规则：售后(9/10/11) > 订单状态；异常关单不替换状态，在状态标签旁另挂一个红色“异常”小标签-->
				<c-state tag async dict="SALES_ORDER_STATE" :value="displayState"></c-state>
				<span v-if="Number(order.abnormal_flag) === 1" class="m-abnormal-tag">异常</span>
			</div>
		</template>

		<module v-if="order.order_no">
			<module-col size="400">
				<c-detail class="m-detail-form">
					<c-detail-item label="销售单号">
						{{order.order_no || '-'}}
					</c-detail-item>
					<c-detail-item v-if="orderType == 2" label="三方订单号">
						{{order.third_party_order_no || order.order_no || '-'}}
					</c-detail-item>
					<c-detail-item v-if="orderType == 2" label="三方质检码">
						{{order.third_party_quality_code || '-'}}
					</c-detail-item>
					<c-detail-item v-if="orderType == 2" label="销售渠道">
						{{order.channel_name || '-'}}
					</c-detail-item>
					<c-detail-item v-if="orderType == 1" label="客户">
						{{order.customer_name || '-'}}
					</c-detail-item>
					<!--是否老系统订单：线下订单才能区分新/老系统，线上订单不展示（口径同线下售后详情）-->
					<c-detail-item v-if="orderType == 1" label="老系统订单">
						<span v-if="Number(order.is_old_order) === 1" class="m-old-order">是</span>
						<span v-else>否</span>
					</c-detail-item>
					<c-detail-item label="订单状态">
                        <c-state async dict="SALES_ORDER_STATE" :value="displayState"></c-state>
					</c-detail-item>
					<!--线下订单取消原因：仅已取消状态展示（系统超时取消、人工取消均落该字段）-->
					<c-detail-item v-if="orderType == 1 && Number(order.order_state) === 5" label="取消原因">
						{{order.cancel_reason || '-'}}
					</c-detail-item>
					<c-detail-item v-if="Number(order.abnormal_flag) === 1" label="异常备注">
						<span style="color: #e53e3e;">{{order.abnormal_remark || '-'}}</span>
					</c-detail-item>
					<c-detail-item label="收货人">
						{{order.receiver_name || '-'}}　{{order.receiver_phone || ''}}
					</c-detail-item>
					<c-detail-item label="收货地址">
						{{order.receiver_address || '-'}}
					</c-detail-item>
					<c-detail-item label="快递信息">
						{{order.express_company || '-'}}　{{order.express_no || ''}}
					</c-detail-item>
					<c-detail-item label="订单总金额">
						{{formatPrice(order.total_amount)}}
					</c-detail-item>
					<c-detail-item label="已付款金额">
						{{formatPrice(order.paid_amount)}}
					</c-detail-item>
					<c-detail-item label="退款信息">
						<span v-if="!Number(order.refund_amount)">-</span>
						<div v-else class="m-product-info">
							<p style="color: #e53e3e;">{{formatPrice(order.refund_amount)}}</p>
							<p class="m-product-info-code">{{order.refund_date || '-'}}</p>
						</div>
					</c-detail-item>
					<c-detail-item v-if="orderType == 2" label="预期结算金额">
						{{formatPrice(order.expect_settle_amount)}}
					</c-detail-item>
					<c-detail-item v-if="orderType == 2" label="结算状态">
						<c-state async dict="SALE_SETTLE_STATE" :value="order.settle_state"></c-state>
					</c-detail-item>
					<c-detail-item label="付款时间">
						{{order.pay_date || '-'}}
					</c-detail-item>
					<c-detail-item v-if="order.order_type == 1" label="创建人">
						{{order.create_user_realname || '-'}}
					</c-detail-item>
					<c-detail-item label="订单创建时间">
						{{order.create_date || '-'}}
					</c-detail-item>
					<c-detail-item label="备注">
						{{order.remark || '-'}}
					</c-detail-item>
				</c-detail>
			</module-col>

			<module-col tab-type="border-tab">
				<module-tab name="商品明细" enable-flex>
					<div class="m-detail-box">
						<c-table :data="productList" border :paging="false">
							<c-table-column label="产品信息" width="300">
								<template #default="{data}">
                                    <m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_code" :imei="data.imei"></m-product-info>
								</template>
							</c-table-column>
							<c-table-column label="售卖类型" width="90">
								<template #default="{data}">
									<c-state async dict="SALE_SELL_TYPE" :value="data.sell_type"></c-state>
								</template>
							</c-table-column>
							<c-table-column label="拆机项" width="140">
								<template #default="{data}">{{getDismantleText(data.dismantle_items)}}</template>
							</c-table-column>
							<c-table-column label="销售价" width="80">
								<template #default="{data}">
									<span style="color: #e53e3e;">{{formatPrice(data.sale_price)}}</span>
								</template>
							</c-table-column>
							<c-table-column label="成本价" width="80">
								<template #default="{data}">{{formatPrice(data.cost_price)}}</template>
							</c-table-column>
							<c-table-column label="退货标记" width="90">
								<template #default="{data}">
									<span v-if="data.return_flag == 1" style="color: #e53e3e;">已退货</span>
									<span v-else>-</span>
								</template>
							</c-table-column>
						</c-table>
					</div>
				</module-tab>

				<module-tab v-if="order.order_type == 1" name="收款记录" enable-flex>
					<div class="m-detail-box">
						<c-table :data="paymentList" border :paging="false">
							<c-table-column label="收款方式" width="140">
								<template #default="{data}">{{getPayChannelName(data.pay_channel)}}</template>
							</c-table-column>
							<c-table-column label="收款金额" width="120">
								<template #default="{data}">{{formatPaymentAmount(data)}}</template>
							</c-table-column>
							<c-table-column label="付款流水号" min-width="160">
								<template #default="{data}">{{data.pay_transaction_no || '-'}}</template>
							</c-table-column>
							<c-table-column label="转账凭证" width="200">
								<template #default="{data}">
									<c-file v-if="data.pay_voucher_url" :src="data.pay_voucher_url"></c-file>
									<span v-else>-</span>
								</template>
							</c-table-column>
							<c-table-column label="备注" min-width="120">
								<template #default="{data}">{{data.remark || '-'}}</template>
							</c-table-column>
							<c-table-column label="操作人" width="100">
								<template #default="{data}">{{data.create_user_realname || '-'}}</template>
							</c-table-column>
							<c-table-column label="收款时间" width="160">
								<template #default="{data}">{{data.pay_date || '-'}}</template>
							</c-table-column>
						</c-table>
					</div>
				</module-tab>

				<!--异常处理记录：只展示本单的业务日志（运营标记、解除异常及取消订单的操作流水）-->
				<module-tab name="异常处理记录" enable-flex>
					<div class="m-detail-box">
						<c-table :data="abnormalLogList" border :paging="false">
							<c-table-column label="操作时间" name="create_date" width="130"></c-table-column>
							<c-table-column label="操作人" width="100">
								<template #default="{data}">{{data.create_user_realname || '-'}}</template>
							</c-table-column>
							<c-table-column label="操作详情" width="600">
								<template #default="{data}">{{data.remark || '-'}}</template>
							</c-table-column>
						</c-table>
					</div>
				</module-tab>
			</module-col>
		</module>
	</c-dialog>
</template>

<script>
	export default {
		name: 'saleOrderDetail',

		props: {
			//订单类型 1=线下 2=线上
			orderType: {
				type: [String, Number],
				default: 2
			}
		},

		data() {
			return {
				orderId: '',
				order: {},
				productList: [],
				paymentList: [],
				abnormalLogList: []
			}
		},

		computed: {
			/*********详情展示状态：和列表同一套规则，由端内自己算，优先级：售后(9/10/11) > 订单状态。
			   异常关单不在这里，页面直接看 abnormal_flag 显示**********/
			displayState() {
				const asState = Number(this.order.after_sale_state);
				if (asState > 0) return asState;
				return this.order.order_state;
			}
		},

		methods: {
			/*********打开抽屉**********/
			open(data = {}) {
				this.orderId = data.orderId;
				this.order = {};
				this.productList = [];
				this.paymentList = [];
				this.abnormalLogList = [];
				this.$refs.dialog.open({title: this.orderType == 1 ? '线下订单详情' : '线上订单详情'});
				this.loadDetail();
			},

            /*********获取产品信息文字**********/
            getProductText(data) {
                var parts = [];
                if (data.brand_name) parts.push(data.brand_name);
                if (data.model_name || data.spu_model_name) parts.push(data.model_name || data.spu_model_name);
                if (data.color_name) parts.push(data.color_name);
                if (data.memory_name) parts.push(data.memory_name);
                return parts.join(' ') || '-';
            },

			/*********加载订单详情**********/
			loadDetail() {
				this.request({
					url: this.orderType == 1 ? '/offline/sale/order/detail' : '/online/sale/order/detail',
					data: {
						order_id: this.orderId
					},
					loading: true,
					success: data => {
						this.order = data.order || {};
						this.productList = data.products || [];
						this.paymentList = data.payments || [];
						this.loadAbnormalLog();
					}
				});
			},

			/*********加载本单异常处理日志（运营处理日志 work_type=12，按 order_id 过滤）**********/
			loadAbnormalLog() {
				this.request({
					url: '/sys/work/log/list',
					data: {
						work_type_id: 12,
						work_id: this.orderId,
						pageIndex: 1,
						pageSize: 50
					},
					success: data => {
						this.abnormalLogList = data || [];
					}
				});
			},

			/*********获取收款方式名称**********/
			getPayChannelName(code) {
				var map = {
					'offline_cash': '现金',
					'offline_qr_code': '收款码',
					'offline_bank_card': '银行转账',
					'credit': '授信支付',
					'wxpay_scan': '微信扫码',
					'alipay_scan': '支付宝扫码'
				};
				return map[code] || code || '-';
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********格式化分为元（支付单金额存的是分）**********/
			formatCent(cent) {
				if (cent === null || cent === undefined || cent === '') return '-';
				return '¥' + (parseFloat(cent) / 100).toFixed(2);
			},

			/*********收款金额（本单已收金额，后端按元下发；没下发时兜底用支付单总额分转元）**********/
			formatPaymentAmount(payment) {
				var amount = payment.trade_amount;
				if (amount !== null && amount !== undefined && amount !== '') {
					return this.formatPrice(amount);
				}
				return this.formatCent(payment.trade_money);
			},

			/*********解析拆机项**********/
			getDismantleText(items) {
				if (!items) return '-';
				try {
					var list = typeof items == 'string' ? JSON.parse(items) : items;
					if (!Array.isArray(list) || !list.length) return '-';
					return list.map(item => item.name || item).join('、');
				} catch (e) {
					return items;
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-detail-tag {
		gap: 8px;
		font-size: 14px;
		font-weight: bold;
	}

	/*老系统订单标识（与线下售后详情同款橙色标签）*/
	.m-old-order {
		display: inline-block;
		padding: 0 6px;
		border-radius: 2px;
		font-size: 12px;
		color: #ff6900;
		background: #fff3e8;
	}

	// 头部状态标签旁的“异常”小标签：跟 c-state tag 同款镂空样式（浅底+描边+红字），配色取异常红
	.m-abnormal-tag {
		display: inline-flex;
		align-items: center;
		height: 24px;
		padding: 0 8px;
		border: 1px solid #f3b7b7;
		border-radius: 4px;
		font-size: 12px;
		font-weight: normal;
		color: #e53e3e;
		background: #fef0f0;
	}

	.m-detail-box {
		padding: 10px;
	}
</style>
